export const FOLLOW_UP_LISTING = "FOLLOW_UP_LISTING";
export const FOLLOW_DETAILS = "FOLLOW_DETAILS";
